import {Typography} from '@hconnect/uikit'
import {Box, ChipProps, CircularProgress, makeStyles} from '@material-ui/core'
import {AxiosError} from 'axios'
import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'

import {useUpmPlant} from '../../../hooks/useUpmPlant'

interface Props {
  upmId: string
  error?: Error
}

const useStyles = makeStyles(() => ({
  plantNumber: {
    fontSize: '14px'
  }
}))

export const RoleUpmPlantLookupChip: FunctionComponent<Props & ChipProps> = ({upmId}) => {
  const {t} = useTranslation()
  const classes = useStyles()

  const plantQueryInfo = useUpmPlant({upmId})

  if (plantQueryInfo.isLoading) {
    return <CircularProgress size="20" />
  }

  if (plantQueryInfo.isError) {
    return (
      <Box>
        <Typography color="textPrimary">{upmId}</Typography>
        <Typography color="textPrimary">Error: Could not load upm plant</Typography>
        <Typography color="textPrimary">{(plantQueryInfo.error as AxiosError).message}</Typography>
      </Box>
    )
  }

  return (
    <Box data-test-id={`role-upm-plant-lookup-chip-${upmId}`}>
      <Typography color="textPrimary">{t('manageUser.umpPlant')}</Typography>
      <Typography color="textPrimary" className={classes.plantNumber}>
        {plantQueryInfo.data?.plantId}
      </Typography>
      <Typography color="textPrimary">{plantQueryInfo.data?.name}</Typography>
    </Box>
  )
}
